// Module
var code = "<div data-moduleicon=\"fpd-icon-grid\" data-defaulttext=\"Swap Product\" data-title=\"modules.products\"> <fpd-dropdown class=\"fpd-product-categories\" searchable></fpd-dropdown> <div class=\"fpd-scroll-area\"> <div class=\"fpd-grid fpd-grid-contain fpd-padding\"> </div> </div> </div>";
// Exports
module.exports = code;